/**
 * FasterWeb
 *
 * Declares its web-accessible resources as `/assets/*` on `<all_urls>` — a glob the
 * auto-generator skips because a wildcard can't be probed. But `/assets/` ships stable,
 * named script files, reachable from any origin at a fixed URL, so a single request is
 * conclusive.
 *
 * `assets/instantpage.js` is the probed path.
 *
 * Manifest verified against version 26.4.4.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'nmgpnfccjfjhdenioncabecepjcmdnjg';

export const fasterweb: ExtensionDefinition = {
  id: ID,
  name: 'FasterWeb',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  notes:
    'Web-accessible resources declared as /assets/* on <all_urls>. The glob is ' +
    'unprobeable, but the shipped script files are stable and reachable from any origin, ' +
    'so a single request identifies the extension.',
  signals: [
    {
      id: 'war-instantpage-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch assets/instantpage.js — a stable, named web-accessible resource exposed ' +
        'on <all_urls>.',
      weight: 1,
      run: () => probeFetch(ID, 'assets/instantpage.js'),
    },
    {
      id: 'war-content-js',
      kind: 'web-accessible-resource',
      description: 'Fetch assets/content.js — a second shipped web-accessible script.',
      weight: 0.5,
      run: () => probeFetch(ID, 'assets/content.js'),
    },
  ],
};
